import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { Button, Intent } from "framework/controls/button";
import { Dialog, DialogContent, DialogTitle } from "framework/dialog/dialog";
import { cls_item_width, cls_button_box, } from "./view.css";
import { cls_colorMagenta60, cls_gap_form, cls_visibility_hidden } from "style/index.css";
import { SearchSelect, SearchSelectItem } from "framework/controls/searchSelect";
import { cls_content_limited_height } from "framework/controls/searchSelect.css";
import { Select, SelectItem } from "framework/controls/select";
import { getEntityField } from "framework/state/setfield";
import { getAdjudicatorLicensesString, getOfficialLicenseStringByRole, OfficialRole } from "public_app/officials/entity";
import { GetEditPermissions } from "../permissions";
import { useif } from "framework/state/types";
import { cls_error } from "framework/controls/select.css";
import { cls_align_items_flex_start, cls_align_items_stretch } from "framework/structural_components/hbox_vbox.css";
import { useEventPlanning_Officials_AllOfficialsList, useEventPlanning_Officials_NewOfficial } from "../store";
export var NewOfficialDialog = function () {
    var _a, _b;
    var _c = useEventPlanning_Officials_NewOfficial(), state = _c[0], actions = _c[1];
    var all_officials_state = useEventPlanning_Officials_AllOfficialsList()[0];
    var onFilter = function (filter) {
        actions.officials_filterOfficials(filter);
    };
    var onSelect = function (idt) {
        if (idt < 0) {
            actions.officials_openRegisterForeignAdjudicatorDialog();
        }
        else {
            actions.officials_selectOfficial(all_officials_state.collection.find(function (x) { return x.id == idt; }));
        }
        actions.officials_filterOfficials('');
    };
    var selectedValue = state.selectedOfficial ? "".concat(state.selectedOfficial.surname, " ").concat(state.selectedOfficial.name, " [").concat(state.selectedOfficial.country, "]") : '';
    var disableButtons = state.submitting;
    var getter = function (field) {
        var value = getEntityField(state, field);
        return value === null || value === void 0 ? void 0 : value.toString();
    };
    var setter = function (field, value, validator, storeInvalidValue) {
        var value2 = value ? Number(value) : "";
        return actions.officials_setNewOfficialRole(value2, validator, storeInvalidValue);
    };
    function OfficialSurnameNameAndLicense(o) {
        var license = getAdjudicatorLicensesString(o);
        return o.surname + " " + o.name + (license != "" ? ", " + license : "");
    }
    var officialForLicense = null;
    if ((_a = state.entity) === null || _a === void 0 ? void 0 : _a.idt) {
        officialForLicense = all_officials_state.collection.find(function (o) { return o.id == state.entity.idt; });
    }
    var editPermissions = GetEditPermissions();
    var roleDisabled = state.entity.role ? true : false;
    if (state.entity.role === OfficialRole.Adjudicator && (editPermissions.Running || editPermissions.r05_judgesAndOfficials)) {
        roleDisabled = false;
    }
    if (state.entity.role === OfficialRole.GeneralInvigilator && editPermissions.Action) {
        roleDisabled = false;
    }
    if (state.entity.role === OfficialRole.SyllabusInvigilator && editPermissions.Action) {
        roleDisabled = false;
    }
    if (state.entity.role === OfficialRole.Scrutineer && (editPermissions.Running || editPermissions.r05_judgesAndOfficials)) {
        roleDisabled = false;
    }
    if (state.entity.role === OfficialRole.Chairperson && (editPermissions.Running || editPermissions.r05_judgesAndOfficials)) {
        roleDisabled = false;
    }
    if (editPermissions.Running) {
        roleDisabled = false;
    }
    // const [event_store] = useEventsPlanningEventEdit();
    // const eventOfficialErrors = event_store.errors['eventCompetitions[0].officials']?.errors;
    var officialGlobalErrors = (_b = state.errors['eventCompetitions[0].officials']) === null || _b === void 0 ? void 0 : _b.errors;
    var toArray = function (err) {
        return err != null ? Array.isArray(err) ? err : [err] : null;
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Dialog, { open: state.showDialog },
            React.createElement(DialogContent, null,
                React.createElement(DialogTitle, null, "Nový odborný pracovník"),
                React.createElement(VBox, { className: [cls_gap_form, cls_align_items_flex_start] },
                    React.createElement(VBox, { className: [cls_item_width, cls_align_items_stretch] },
                        React.createElement(SearchSelect, { label: "Jm\u00E9no", name: "idt", onFilter: onFilter, selectedValue: selectedValue, onSelect: onSelect, state: state, contentClassName: [cls_content_limited_height, cls_item_width], placeholder: "Zadejte několik znaků příjmení..." }, state.filteredOfficials.map(function (o) { return React.createElement(SearchSelectItem, { key: o.id, keyValue: o.id }, OfficialSurnameNameAndLicense(o)); }))),
                    React.createElement(VBox, { className: [cls_item_width, cls_align_items_stretch] },
                        React.createElement(Select, { name: "role", state: state, getter: getter, setter: setter, contentClassName: cls_item_width, className: useif(roleDisabled, cls_error) }, state.availableOfficialRoles.map(function (r) { return React.createElement(SelectItem, { key: r.key, value: r.key.toString(), children: r.value + (officialForLicense ? ", " + getOfficialLicenseStringByRole(officialForLicense, r.key) : "") }); }))),
                    roleDisabled ? React.createElement(HBox, { className: [cls_item_width, cls_gap_form, cls_colorMagenta60] }, "Nemáte oprávnění pro přidání odborného pracovníka s touto rolí.") : null,
                    React.createElement(HBox, { className: [cls_item_width, cls_gap_form] },
                        React.createElement(VBox, { className: [cls_align_items_stretch, cls_button_box] },
                            React.createElement(Button, { onClick: function () { return actions.officials_addSelectedOfficial(); }, disabled: disableButtons || roleDisabled, className: useif(roleDisabled, cls_visibility_hidden) }, 'Přidat'))),
                    React.createElement(HBox, null),
                    React.createElement(HBox, { className: [cls_item_width, cls_gap_form] },
                        React.createElement(VBox, { className: [cls_align_items_stretch, cls_button_box] },
                            React.createElement(Button, { onClick: actions.officials_openRegisterForeignAdjudicatorDialog, disabled: disableButtons, intent: Intent.NotAction }, 'Zahraniční porotce'))),
                    React.createElement(HBox, { className: [cls_item_width, cls_gap_form] },
                        React.createElement(VBox, { className: [cls_align_items_stretch, cls_button_box] },
                            React.createElement(Button, { onClick: actions.officials_closeDialog, disabled: disableButtons, intent: Intent.NotAction }, 'Zavřít'))),
                    officialGlobalErrors && React.createElement(VBox, null, toArray(officialGlobalErrors).map(function (err, i) { return React.createElement(VBox, { key: i, className: cls_colorMagenta60 }, err); }))))));
};
